import { makePatchRequest } from 'owa-ows-gateway';
import { CLOUD_SETTINGS_BASE_URL } from './loadOcsTranslationSettings';

export default async function saveOcsTranslationSettings(settingToUpdate: any[]) {
    return makePatchRequest(
        CLOUD_SETTINGS_BASE_URL,
        settingToUpdate,
        null,
        true,
        {
            Accept: 'application/json',
            'x-overridetimestamp': true,
        } /* customHeader */
    );
}
